PluginRegistry.add('route', {
    'url': '/monitor/backup-and-restore',
    'module': 'graphdb.framework.monitoring.backupandrestore',
    'path': 'backup-and-restore/app',
    'chunk': 'monitor-backup-and-restore',
    'controller': 'BackupAndRestoreCtrl',
    'templateUrl': 'pages/monitor/backup-and-restore.html',
    'title': 'view.monitoring.backup_and_restore.title',
    'helpInfo': 'view.monitoring.backup_and_restore.helpInfo',
    'documentationUrl': 'backup-and-restore.html#monitoring-your-recovery-operations'
});

PluginRegistry.add('main.menu', {
    'items': [
        {
            label: 'Backup and Restore',
            labelKey: 'menu.backup_and_restore.label',
            href: 'monitor/backup-and-restore',
            order: 2,
            parent: 'Monitor',
            guideSelector: 'sub-menu-backup-and-restore',
            testSelector: 'sub-menu-backup-and-restore',
            role: 'ROLE_REPO_MANAGER'
        }
    ]
});
